/**
 * Handles photo carousel interactions for analytics tracking
 * @param listingId - The ID of the listing
 * @param source - The source of the photo carousel interaction
 * @returns void
 */
export const handlePhotoCarouselInteraction = (
  listingId: string,
  source: string = "listing gallery",
) => {
  window.analyticsIntegrations.photoCarouselInteraction(listingId, source);
};
